import React, { type FC, type RefObject, memo, useCallback } from 'react';
import { useDuplicatesAnalytic } from 'reactApp/hooks/duplicates/useDuplicatesAnalytic';
import { BEST_PHOTO_TOOLTIP_ID } from 'reactApp/modules/duplicates/duplicates.constants';
import { getBestPhotoTooltipShown } from 'reactApp/modules/duplicates/duplicates.helpers';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { FloatingTooltip } from 'reactApp/ui/FloatingTooltip/FloatingTooltip';
import { ETooltipPlacement, ETooltipSize } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './BestPhotoTooltip.css';

interface IProps {
    target: RefObject<HTMLElement> | Element | null;
}

const text = 'Это\u00A0лучшее\u00A0фото\u00A0— оно\u00A0сохранится после\u00A0удаления дубликатов';

const onClose = () => {
    storeHelper.setValue(BEST_PHOTO_TOOLTIP_ID, true);
};

export const BestPhotoTooltip: FC<IProps> = memo(function BestPhotoTooltip(props: IProps) {
    const { target } = props;
    const analyticData = useDuplicatesAnalytic();

    const onShow = useCallback(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.duplicates,
            action: 'tooltip-show',
            tooltip_type: 'best-photo',
            ...analyticData,
        });
    }, [analyticData]);

    if (getBestPhotoTooltipShown()) {
        return null;
    }

    return (
        <FloatingTooltip
            target={target}
            placement={ETooltipPlacement.bottom}
            size={ETooltipSize.fit}
            closeOnContextMenu={true}
            onClose={onClose}
            onShow={onShow}
            usePortal={true}
            closable={false}
        >
            <div className={styles.root}>
                <span>{text}</span>
            </div>
        </FloatingTooltip>
    );
});

BestPhotoTooltip.displayName = 'BestPhotoTooltip';
